// extracted by mini-css-extract-plugin
export default {"optInWrap":"OptInInfo_optInWrap__YXys8","optInIcon":"OptInInfo_optInIcon__beYj5"};